export const locale = {
    lang: 'pl',
    data: {
        'Personal data': 'Dane dodatkowe',
        'Summary': 'Podsumowanie',
        'Cards': 'Karty',
        'Orders': "Zamówienia",
        'Reservations': 'Rezerwacje',
        'Notification history': 'Historia wiadomości',
        'Add note': 'Dodaj notatkę',
        'Open bill': 'Otwarty rachunek',
    }
};
